import * as Sentry from "@sentry/nextjs";

import Logger from "@/lib/utils/logger";

let reported = false;

/**
 * Makes "Clerk never loaded" visible in Sentry, once per page load (TX-5483).
 *
 * When a browser blocks Clerk, sign-in cannot start and nothing used to be
 * logged or reported — the first sign of it was a member's screenshot. The
 * browser logger stays in the console, so the report goes to Sentry directly,
 * as the other monitoring reporters do. No member data: the visitor is not
 * signed in, and the email they typed is never included.
 */
export function reportClerkUnavailable(waitedMs: number): void {
  if (reported) return;
  reported = true;
  const path = typeof window === "undefined" ? undefined : window.location.pathname;
  Logger.warn("[Auth] Clerk did not load; sign-in is unavailable", { waitedMs, path });
  Sentry.captureMessage("Clerk did not load in the browser; sign-in is unavailable", {
    level: "warning",
    tags: { surface: "clerk-load" },
    extra: { waitedMs, path },
  });
}

/** Tests only: lets each test see its own first report. */
export function resetClerkUnavailableReportForTests(): void {
  reported = false;
}
